import { cpvCodesApi, type CpvCode } from '../api/cpvCodes'

/**
 * Module-level cache so the full CPV catalog is fetched once per session and
 * shared between every consumer (CpvPicker, both CpvCombobox instances)
 * instead of each one issuing its own request. A failed request is not
 * cached — the next caller retries the fetch rather than being stuck with
 * the failure for the rest of the session.
 */
let inflight: Promise<CpvCode[]> | undefined

export function loadCpvCodes(): Promise<CpvCode[]> {
  if (!inflight) {
    inflight = cpvCodesApi.list().catch((err: unknown) => {
      inflight = undefined
      throw err
    })
  }
  return inflight
}

/** Test-only: clears the module-level cache so specs don't leak state into each other. */
export function resetCpvCodesCache(): void {
  inflight = undefined
}
